<template>
  <div>
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="row">
      <div class="col-md-12">
        <div class="top-list-toolbar">
          <div>
            <h4 class="text-primary" @click="backParent">Sale Order</h4>
            <ol class="breadcrumb breadcrumb-card-header">
              <li class="breadcrumb-item">
                <a href="javascript:void(0);" @click="backParent">Sale Order</a>
              </li>
              <li class="breadcrumb-item active">
                <span v-if="order.id === null">New</span>
                <span v-else>
                  {{ order.order_no }}
                </span>
              </li>
            </ol>
            <button class="btn btn-success btn-sm pull-left dropdown-toggle" type="button" id="action" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-show="order.order_no !== null">Action</button>
            <div class="dropdown-menu" aria-labelledby="action">
              <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalRequestEdit" data-backdrop="static" data-keyboard="false">Request Edit</a>
              <a class="dropdown-item" href="javascript:void(0)" data-toggle="modal" data-target="#modalRequestVoid" data-backdrop="static" data-keyboard="false">Request Delete</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="resetOrderDone">Reset Qty Done</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="syncOrderAll">Sync Order</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="printSO">Print</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="removeOrder" v-show="authUser.permissions.sale_order_delete">Delete</a>
              <a class="dropdown-item" href="javascript:void(0)" @click="unlock" v-show="authUser.permissions.sale_order_unlock">Unlock</a>
            </div>
            <button type="button" @click="updateSales" class="btn btn-sm btn-soft-primary pull-left" v-show="order.order_no !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
            <button type="button" @click="createSales" class="btn btn-sm btn-soft-primary pull-left" v-show="order.order_no == null"><i class="fa fa-save" aria-hidden="true"></i> Create</button>
            <button type="button" @click="approveSales" class="btn btn-sm btn-soft-primary pull-left" v-show="order.order_no !== null"><i class="fa fa-check" aria-hidden="true"></i> Approve</button>
            <button type="button" @click="validateDetailDuplicate" class="btn btn-sm btn-soft-primary pull-left" ><i class="fa fa-check" aria-hidden="true"></i> Validate</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card card-list">
          <div class="card-header">
            <h5 v-if="order.order_no === null">New</h5>
            <h5 v-else>
              {{ order.order_no }}
              <span class="badge badge-primary" v-if="order.status === 'deal'">{{ order.status }}</span>
              <span class="badge badge-danger" v-else-if="order.status === 'old'">{{ order.status }}</span>
              <span class="badge badge-success" v-else>{{ order.status }}</span>
            </h5>
          </div>
          <div class="card-body">
            <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
              <ul v-for="(a, index) in alert" :key="index">
                <li v-html="a.message"></li>
              </ul>
            </div>
            <div class="row">
              <div class="col-md-4">
                <dl class="row dl-custom font-12">
                  <dt class="col-md-4">Customer</dt>
                  <dd class="col-md-8">
                    <button type="button" data-toggle="modal" data-target="#modalCustomerForm" data-backdrop="static" data-keyboard="false"  class="btn btn-sm btn-soft-primary mr-1" :disabled="order.lock">+ New</button>
                    <button type="button" data-toggle="modal" data-target="#modalCustomerList" data-backdrop="static" data-keyboard="false"  class="btn btn-sm btn-soft-primary" @click="getCustomerList" :disabled="order.lock">List</button>
                  </dd>

                  <dt class="col-md-4">Name</dt>
                  <dd class="col-md-8">{{ order.customer.name }}</dd>

                  <dt class="col-md-4">Phone</dt>
                  <dd class="col-md-8">{{ order.customer.phone }}</dd>

                  <dt class="col-md-4">Address</dt>
                  <dd class="col-md-8">{{ order.customer.address }}</dd>

                  <dt class="col-md-4">Rating</dt>
                  <dd class="col-md-8">
                    <span class="badge badge-success" v-if="order.customer.rating_id === 'good'">{{ order.customer.rating }}</span>
                    <span class="badge badge-warning" v-else-if="order.customer.rating_id === 'middle-low'">{{ order.customer.rating }}</span>
                    <span class="badge badge-warning" v-else-if="order.customer.rating_id === 'vip'">{{ order.customer.rating }}</span>
                    <span class="badge badge-warning" v-else-if="order.customer.rating_id === 'evaluate'">{{ order.customer.rating }}</span>
                    <span class="badge badge-danger" v-else>{{ order.customer.rating }}</span>
                  </dd>

                  <dt class="col-md-4">Plafond</dt>
                  <dd class="col-md-8">{{ customerPlafondAmount | currency }}</dd>

                  <dt class="col-md-4">Oustanding</dt>
                  <dd class="col-md-8">{{ customerOutstandingTotal | currency }} [{{ customerOutstandingTotalSales }}] [{{ customerOutstandingTotalSalePaid }}]</dd>

                  <dt class="col-md-4">Oustanding Overdue ({{ settingDueDatePlafond }}):</dt>
                  <dd class="col-md-8">{{ customerOutstandingDueTotal | currency }}</dd>
                </dl>
                <!-- <div>
                  <pre>customerOutstandingDueTotal: {{ customerOutstandingDueTotal}}</pre>
                  <pre>customerOutstandingTotal: {{  }}</pre>
                  <pre>customerPlafondAmount: {{ customerPlafondAmount }}</pre>
                  <pre>isEnablePlafond: {{ isEnablePlafond }}</pre>
                  <pre>isEnablePlafondDueDate: {{ isEnablePlafondDueDate }}</pre>
                </div> -->
                <hr/>
              </div>
              <div class="col-md-4">
                <dl class="row dl-custom">
                  <dt class="col-md-4">SP No.</dt>
                  <dd class="col-md-8">
                    <span v-if="order.lock">{{ order.project_name }}</span>
                    <input v-else type="text" class="form-control form-control-lite" v-model="order.project_name" @blur="getSpNo"/>
                    <span style="color: red" v-if="error.project_name !== ''">{{ error.project_name }}</span>
                  </dd>

                  <dt class="col-md-4">Tanggal</dt>
                  <dd class="col-md-8">
                    <span v-if="order.lock">{{ order.order_date | dateFormat('DD/MM/YYYY') }}</span>
                    <datetime v-else v-model="order.order_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="Asia/Jakarta" zone="Asia/Jakarta" :disabled="order.lock"></datetime>
                  </dd>

                  <dt class="col-md-4">Term. Tempo</dt>
                  <dd class="col-md-8">
                    <select v-model="order.term_due_id" class="form-control form-control-lite" :disabled="order.lock">
                      <option v-for="t in termDueList" :key="t.id" :value="t.id">{{ t.name }}</option>
                      <option value=""><i>Custom</i></option>
                    </select>
                  </dd>

                  <dt class="col-md-4">Tgl. Jatuh Tempo</dt>
                  <dd class="col-md-8">
                    <span v-if="order.lock">{{ order.order_due_date | dateFormat('DD/MM/YYYY') }}</span>
                    <datetime v-else v-model="order.order_due_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="Asia/Jakarta" zone="Asia/Jakarta" :disabled="order.lock"></datetime>
                  </dd>
                </dl>
                <hr>
                <dl class="row dl-custom">
                  <dt class="col-md-4">Salesman</dt>
                  <dd class="col-md-8">
                    <v-select :options="getUserSalesman" :reduce="salesman => salesman.meta.code" label="salesman" v-model="order.salesman_id" class="vsc-custom" :disabled="order.lock"/>
                  </dd>

                  <dt class="col-md-4">Company</dt>
                  <dd class="col-md-8">
                    <select v-model="order.company_no" class="form-control form-control-lite" @change="checkTax" :disabled="order.lock || order.order_no !== null">
                      <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                    </select>
                  </dd>

                  <dt class="col-md-4">Tax</dt>
                  <dd class="col-md-8">
                    <select v-model="order.tax_id" class="form-control form-control-lite" @change="setTax" :disabled="order.lock">
                      <option v-for="t in taxList" :key="t.id" :value="t.id">Tax: {{ t.name }}</option>
                    </select>
                  </dd>

                  <!-- <dt class="col-md-4">Down Payment</dt>
                  <dd class="col-md-8">
                    <span v-if="order.lock">{{order.down_payment | currency }}</span>
                    <input v-else type="text" v-money="money" class="form-control form-control-lite"  v-model="order.down_payment"/>
                  </dd> -->

                  <!-- <dt class="col-md-4">Down Payment Date</dt>
                  <dd class="col-md-8">
                    <span v-if="order.lock">{{ order.down_payment_date | dateFormat('DD/MM/YYYY') }}</span>
                    <datetime v-else v-model="order.down_payment_date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="Asia/Jakarta" zone="Asia/Jakarta" :disabled="order.lock"></datetime>
                  </dd> -->

                  <!-- <dt class="col-md-4">Price List</dt>
                  <dd class="col-md-8">
                    <select v-model="order.price_id" class="form-control form-control-lite" :disabled="order.lock">
                      <option value="">-- Price List --</option>
                      <option v-for="p in priceListGroup" :key="p.id" :value="p.id">{{ p.name }}</option>
                    </select>
                  </dd> -->
                </dl>
              </div>
              <div class="col-md-4">
                <strong class="font-14">Sales:</strong>
                <ul v-for="p in order.sales" :key="p.id">
                  <li>
                    <span style="cursor: pointer; color: blue;" @click="getSaleNo(p.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">
                      {{ p.sale_no }}
                    </span>
                    - {{ p.sale_date | dateFormat('DD/MM/YYYY') }}
                    <!-- <span class="ml-2 font-16" style="color: red; cursor: pointer" @click="removePurchasing(index)" v-if="inventory.lock !== true"><i class="fa fa-trash-o" aria-hidden="true"></i></span> -->
                  </li>
                </ul>
              </div>
            </div>
            <ul class="nav nav-tabs nav-bordered">
              <li class="nav-item">
                <a href="#product" data-toggle="tab" aria-expanded="false" class="nav-link active">
                  Product
                </a>
              </li>
              <!-- <li class="nav-item"><a href="#expense" data-toggle="tab" aria-expanded="false" class="nav-link">Opex</a></li> -->
              <li class="nav-item"><a href="#notes" data-toggle="tab" aria-expanded="false" class="nav-link">Notes</a></li>
              <li class="nav-item"><a href="#attachment" data-toggle="tab" aria-expanded="false" class="nav-link">Attachment</a></li>
              <li class="nav-item"><a href="#sales" data-toggle="tab" aria-expanded="false" class="nav-link">Sales</a></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="product">
                <div class="row">
                  <div class="col-md-12">
                    <!-- <button type="button" data-toggle="modal" data-target="#modalSaleOrder" data-backdrop="static" data-keyboard="false"  class="btn btn-sm btn-primary pull-right ml-1" @click="getProductList">Template</button> -->
                  </div>
                </div>
                <div class="row  mx-auto">
                  <div :class="card1">
                    <div class="table-responsive">
                      <table class="table table-sm table-item table-striped">
                          <thead>
                              <th style="width: 15%">Product No</th>
                              <th style="width: 15">Description</th>
                              <th>Qty</th>
                              <th>Done</th>
                              <th style="width: 10%">UoM</th>
                              <th class="text-right">Price</th>
                              <th class="text-right">Discount%</th>
                              <th class="text-right">Subtotal(DPP)</th>
                              <th class="text-right">Tax</th>
                              <th class="text-right">Total</th>
                              <!-- <th style="width: 10%" class="text-right">HPP</th> -->
                              <!-- <th style="width: 10%" class="text-right">Margin</th> -->
                              <!-- <th style="width: 10%" class="text-right">%</th> -->
                              <th class="text-right">#</th>
                          </thead>
                          <tbody>
                              <tr v-for="(d, index) in order.details" :key="d.id" >
                                <td>
                                  <p class="input-group">
                                    <input type="text" class="form-control" v-model="d.product_no" disabled="disabled" />
                                    <span class="input-group-btn ml-1">
                                      <button data-toggle="modal" data-target="#modalGetProduct" data-backdrop="static" data-keyboard="false" type="button" class="btn btn-outline-primary btn-sm" @click="setIdDetail(index)" v-if="order.lock === false"><i class="fa fa-search" aria-hidden="true"></i></button>
                                    </span>
                                  </p>
                                </td>
                                <td>{{ d.description }}</td>
                                <td><input type="text" v-model="d.qty" class="form-control" v-on:keyup="calcRowPrice(index)" :disabled="order.lock"/></td>
                                <td><input type="text" v-model="d.qty_done" class="form-control" disabled="disabled"/></td>
                                <td>
                                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="d.uom_id === null"></span>
                                  <span v-else>
                                    <select v-model="d.uom_id" class="form-control" @change="calcRowPrice(index)" :disabled="order.lock">
                                      <option v-for="u in d.uomList" :value="u.id" :key="u.id">{{ u.name }}</option>
                                    </select>
                                  </span>
                                </td>
                                <td><input type="text" v-model="d.price" v-money="money" class="form-control form-right" v-on:keyup="calcRowPrice(index)" :disabled="order.lock"/></td>
                                <td><input type="text" v-model="d.discount_percentage" class="form-control form-right" v-on:keyup="calcRowPrice(index)" :disabled="order.lock"/></td>
                                <td class="text-right">{{ d.subtotal | currency }}</td>
                                <td class="text-right">{{ d.tax | currency }}</td>
                                <td class="text-right">{{ d.total | currency }}</td>
                                <!-- <td><input type="text" v-model="d.cost" v-money="money" class="form-control form-right" v-on:keyup="calcRowPrice(index)"/></td> -->
                                <!-- <td class="text-right">{{ d.margin | currency }}</td> -->
                                <!-- <td class="text-right">{{ d.margin_percentage }} %</td> -->
                                <td class="text-right">
                                  <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removeDetail(index)" v-if="order.lock === false" :disabled="order.lock"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                  <button type="button" class="btn btn-sm btn-hard-primary" @click="syncOrder(index)"  v-if="order.lock === false" :disabled="order.lock"><i class="fa fa-refresh"></i></button>
                                  <!-- <button type="button" class="btn btn-sm btn-hard-primary" @click="selectProductToSaleList(d.product_no)" :disabled="order.lock">
                                    <i class="fa fa-share" aria-hidden="true"></i>
                                  </button> -->
                                </td>
                              </tr>
                              <tr>
                                <td>
                                    <a href='#' data-toggle="modal" data-target="#modalSaleDetail" data-backdrop="static" data-keyboard="false" style="cursor: pointer" @click="addNewLine" v-if="order.lock === false" class="link-secondary">
                                      + Add Product
                                    </a>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                              </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colspan="9" class="text-right">Subtotal</td>
                              <td class="text-right">{{ order.subtotal | currency }}</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="9" class="text-right">Discount</td>
                              <td class="text-right">({{ order.discount | currency }})</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="9" class="text-right">Tax</td>
                              <td class="text-right"><i>{{ order.tax | currency }}</i></td>
                              <td></td>
                            </tr>
                            <tr>
                              <td colspan="9" class="text-right"><h5><b>Total</b></h5></td>
                              <td class="text-right"><h5><b>{{ order.total | currency }}</b></h5></td>
                              <td></td>
                            </tr>
                            <!-- <tr><td colspan="11">&nbsp;</td></tr> -->
                            <!-- <tr>
                              <td colspan="7" class="text-right">Total Cost</td>
                              <td class="text-right">{{ getTotalCost | currency }}</td>
                              <td></td>
                            </tr> -->
                            <!-- <tr>
                              <td colspan="7" class="text-right"><b>Gross Profit</b></td>
                              <td class="text-right"><b>{{ getGrossProfit | currency }}</b></td>
                              <td><b>{{ getGrossProfitPercentage }}%</b></td>
                            </tr> -->
                            <!-- <tr>
                              <td colspan="7" class="text-right">Total Opex</td>
                              <td class="text-right">{{ getTotalExpense | currency }}</td>
                              <td></td>
                            </tr> -->
                            <!-- <tr>
                              <td colspan="7" class="text-right"><b>Net Profit</b></td>
                              <td class="text-right"><span><b>{{ getNetProfit | currency }}</b></span></td>
                              <td><b>{{ getNetProfitPercentage }}%</b></td>
                            </tr> -->
                          </tfoot>
                      </table>
                    </div>
                  </div>
                  <div :class="card2" v-if="card2 != null">
                    <input type="search" class="form-control" v-model="searchQueryOrder" placeholder="search..."/>
                    <div class="table-responsive">
                      <table class="table table-sm table-item table-hover table-striped">
                        <thead>
                          <th>Qty</th>
                          <th>Uom</th>
                          <th>Sale No.</th>
                          <th>Product No.</th>
                          <th>Product name</th>
                        </thead>
                        <tbody>
                          <tr v-for="c in customerSalesList" :key="c.id">
                            <td>{{ c.qty }}</td>
                            <td>{{ c.uom_id }}</td>
                            <td>{{ c.sale_no }}</td>
                            <td>{{ c.product_no }}</td>
                            <td>{{ c.product }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <h5>Term & Conditions:</h5>
                    <div class="col-md-3">
                      <div class="form-group row">
                        <select class="form-control" @change="getTermCondition" v-model="order.term_no" >
                          <option value="">---</option>
                          <option v-for="i in salesTermConditionList" :key="i.id" :value="i.term_no">{{ i.term_name }}</option>
                        </select>
                      </div>
                    </div>
                    <wysiwyg v-model="order.term_notes" />
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="expense">
                <div class="row">
                  <div class="offset-md-2 col-md-8">
                    <table class="table table-sm table-item table-striped">
                      <thead>
                        <th style="width: 50%">Term</th>
                        <th>Amount</th>
                      </thead>
                      <tbody>
                        <tr v-for="e in getOrderExpenseTerm" :key="e.description">
                          <td class="text-right"><b>{{ e.description }}</b></td>
                          <td>
                            <input type="text" v-model="e.amount" class="form-control" />
                          </td>
                        </tr>
                        <tr>
                          <th colspan="2">Biaya</th>
                        </tr>
                        <tr v-for="e in getOrderExpenseBiaya" :key="e.description">
                          <td class="text-right"><b>{{ e.description }}</b></td>
                          <td>
                            <input type="text" v-model="e.amount" v-money="money" class="form-control form-right" style="float: right; clear: both;"/>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <th></th>
                        <th class="text-right">{{ getTotalExpense | currency}}</th>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <!-- <pre>{{ order.expenses }}</pre> -->
              </div>
              <div class="tab-pane" id="notes">
                <div class="row">
                  <div class="col-md-12">
                    <wysiwyg v-model="order.survey_notes" />
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="attachment">
                <div class="row">
                  <div class="col-md-12">
                    <h5>Attachment</h5>
                    <div class="row">
                      <div class="col-md-12">
                        <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
                        <button type="button" @click="upload" class="btn btn-outline-primary" v-show="uploading">
                          Upload
                        </button>
                        <button class="btn btn-primary btn-block btn-login" type="button" disabled v-show="loading">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>uploading...
                        </button>
                      </div>
                    </div>
                    <hr>
                    <div class="row">
                      <div class="col-md-12">
                        <ul>
                          <li v-for="a in getAttachment" :key="a.id">
                            <span @click="downloadAttachments(a.url, a.filename)" style="cursor: pointer; color: blue">{{ a.filename }}</span>
                            <span @click="removeAttachments(a.id)" class="ml-2"><i class="fa fa-times" aria-hidden="true"  style="cursor: pointer; color: red"></i></span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane" id="sales">
                <div class="table-responsive">
                  <table class="table table-sm table-item">
                    <thead>
                      <th>Status</th>
                      <th>Sale No</th>
                      <th>Date</th>
                      <th>Total</th>
                    </thead>
                    <tbody>
                      <tr v-for="s in order.sales" :key="s.id">
                        <td>
                          <span class="badge badge-success" v-if="s.status === 'completed'">{{ s.status }}</span>
                          <span class="badge badge-warning" v-else-if="s.status === 'outstanding'">{{ s.status }}</span>
                          <span class="badge badge-primary" v-else-if="s.status === 'approved'">{{ s.status }}</span>
                          <span class="badge badge-warning" v-else-if="s.status === 'order'">{{ s.status }}</span>
                          <span class="badge badge-danger" v-else>{{ s.status }}</span>
                        </td>
                        <td>{{ s.sale_no }}</td>
                        <td>{{ s.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                        <td>{{ s.total | currency }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <SalesDetailModal :idDetail="idDetail" :sales="order" @selectProduct="selectProduct" :amountDue="getTotal"/> -->
    <SalesProductModal @selectProduct="selectProduct" :sales="order" :status="status" :date="order.order_date" ref="refreshProduct"/>
    <CustomerFormModal @createCustomer="createCustomer" />
    <CustomerListModal @selectCustomerList="selectCustomerList" />
    <SaleOrderAttachmentModal :order="order"/>
    <SaleOrderDealFormModal :sales="dataSales" @processSales="processSales"/>
    <SaleModal />
    <SalesRequestModal @getRequestEdit="requestEdit" @getRequestVoid="requestVoid"/>
    <div class="row justify-content-md-center">
      <div class="col-md-6">
        <h5>Logs:</h5>
        <div class="alert alert-info" role="alert" v-for="l in order.logs" :key="l.id">
          <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
        </div>
      </div>
    </div>
    <!-- <pre>{{ order }}</pre> -->
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import SalesProductModal from '@/components/sales/SalesProductModal.vue'
import CustomerFormModal from '@/components/customer/CustomerFormModal.vue'
import CustomerListModal from '@/components/customer/CustomerListModal.vue'
import SaleOrderAttachmentModal from '@/components/sales/SaleOrderAttachmentModal.vue'
import SaleOrderDealFormModal from '@/components/sales/SaleOrderDealFormModal.vue'
import SaleModal from '@/components/sales/SaleModal.vue'
import { saleOrderUrl, getHeader, productUrl, salesUrl, customerUrl, lockUrl, sale2Url } from '../../config'
import Loading from 'vue-loading-overlay'
import SalesRequestModal from '@/components/sales/SalesRequestModal.vue'

export default {
  name: 'SaleOrderForm',
  props: ['order'],
  components: {
    SalesProductModal,
    CustomerFormModal,
    CustomerListModal,
    SaleOrderAttachmentModal,
    SaleOrderDealFormModal,
    SaleModal,
    Loading,
    SalesRequestModal
  },
  created () {
    // Add barcode scan listener and pass the callback function
    this.$barcodeScanner.init(this.onBarcodeScanned)
    // this.getType()
  },
  destroyed () {
    // Remove listener when component is destroyed
    this.$barcodeScanner.destroy()
  },
  data () {
    return {
      alert: [],
      card1: 'col-md-12',
      card2: null,
      searchQueryOrder: '',
      status: 'order',
      validateCustomerStatus: false,
      error: {
        project_name: ''
      },
      dataSales: {
        id: null,
        sale_no: null,
        sale_date: null,
        sale_due_date: null,
        type_id: null,
        type: null,
        customer_no: null,
        customer: {
          id: null,
          customer_no: null,
          name: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null
        },
        branch_no: null,
        warehouse_no: null,
        branch: null,
        subtotal: null,
        tax_id: null,
        taxes: null,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        salesman_id: null,
        salesman: null,
        status: null,
        price_id: null,
        price_list: null,
        overdue: '',
        order_no: null,
        company_no: null,
        details: [{
          id: null,
          sale_no: null,
          sale_date: null,
          branch_no: null,
          branch: null,
          product_no: null,
          product_sku: null,
          product: null,
          products: {
            canBarcode: null
          },
          description: null,
          barcode: null,
          qty: null,
          qty_done: null,
          serial_number: null,
          sec_serial_number: null,
          uom_id: null,
          price: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          queue: null,
          warehouse_no: null,
          uomType: [{
            id: null,
            name: null,
            category_id: null,
            type_id: null,
            ratio: '0',
            active: false,
            cost: '0',
            price: '0'
          }],
          cost: '0',
          cost_id: null,
          margin: '0',
          margin_percentage: '0',
          internal_code: null
        }]
      },
      isTax: false,
      termCondition: null,
      file: null,
      loading: false,
      uploading: true,
      idDetail: null,
      detail: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  computed: {
    ...mapState({
      salesTypeList: state => state.sales.salesTypeList,
      branchList: state => state.branches.branchList,
      productList: state => state.products.productList,
      uomList: state => state.uom.uomList,
      userList: state => state.users.userAll,
      taxList: state => state.taxes.taxList,
      priceListGroup: state => state.priceLists.priceListGroup,
      salesTermConditionList: state => state.sales.salesTermConditionList,
      termDueList: state => state.termduedates.termDueList,
      companyList: state => state.companies.companyList,
      employeeList: state => state.employees.employeeList,
      authUser: state => state.users.authUser,
      warehouseList: state => state.warehouses.warehouseList,
      customerOutstandingTotal: state => state.customers.customerOutstandingTotal,
      customerOutstandingDueTotal: state => state.customers.customerOutstandingDueTotal,
      customerOutstandingTotalSales: state => state.customers.customerOutstandingTotalSales,
      customerOutstandingTotalSalePaid: state => state.customers.customerOutstandingTotalSalePaid,
      customerPlafondAmount: state => state.customers.customerPlafondAmount,
      customerRatingList: state => state.customers.customerRatingList,
      settingList: state => state.data.settingList
    }),
    settingDueDatePlafond () {
      let dueDateCount = 0
      const settingPlafond = this.settingList.find(d => d.name === 'customer_sales_plafond_due_date_enable' && d.company_no === this.order.company_no)
      if (settingPlafond) {
        dueDateCount = settingPlafond.value
      }
      return dueDateCount
    },
    isEnablePlafond () {
      let check = false
      const setting = this.settingList.find(d => d.name === 'customer_sales_plafond_enable' && d.company_no === this.order.company_no)
      console.log('isEnablePlafond: ')
      console.log(setting)
      if (setting) {
        check = setting.active
      }
      return check
    },
    isEnablePlafondDueDate () {
      let check = false
      const setting = this.settingList.find(d => d.name === 'customer_sales_plafond_due_date_enable' && d.company_no === this.order.company_no)
      if (setting) {
        check = setting.active
      }
      return check
    },
    totalDetailSubtotal () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].subtotal * parseInt(array[i].qty))
      }
      return sum
    },
    totalDetail () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalDetailTax () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].tax)
      }
      return sum
    },
    totalDetailDiscount () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].discount)
      }
      return sum
    },
    customerSalesList () {
      var array = this.order.sales
      var loop = []
      if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
          var arrDetail = array[i].details
          if (arrDetail.length > 0) {
            for (let a = 0; a < arrDetail.length; a++) {
              var obj = {
                id: arrDetail[a].id,
                sale_no: array[i].sale_no,
                sale_date: array[i].sale_date,
                product_no: arrDetail[a].product_no,
                product: arrDetail[a].description,
                qty: arrDetail[a].qty,
                uom_id: arrDetail[a].uom_id
              }
              loop.push(obj)
            }
          }
        }
      }
      return loop.filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQueryOrder.toLowerCase()) > -1) {
              return d
            }
          }
        }
      })
    },
    getAttachment: function () {
      return this.order.attachments.filter(d => d.id !== null)
    },
    getOrderExpenseTerm: function () {
      return this.order.expenses.filter(d => d.type === 'term')
    },
    getOrderExpenseBiaya: function () {
      return this.order.expenses.filter(d => d.type !== 'term')
    },
    getTotalExpense: function () {
      // var manPower = this.order.expenses.find(d => d.description === 'Man Power')
      // var workDay = this.order.expenses.find(d => d.description === 'Working day')
      // console.log('working day')
      // console.log(workDay)
      // var array = this.order.expenses.filter(d => d.type === 'biaya').filter(d => d.description !== 'Transport')
      // console.log(array)
      var sum = 0
      // for (let i = 0; i < array.length; i++) {
      //   sum += (parseFloat(array[i].amount.replace(/\./g, '')) * parseFloat(manPower.amount)) * workDay.amount
      // }
      // var transport = this.order.expenses.find(d => d.type === 'biaya' && d.description === 'Transport')
      // if (transport) {
      //   sum = sum + parseFloat(transport.amount.replace(/\./g, ''))
      // }
      return sum
    },
    getTotalCost: function () {
      var array = this.order.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].qty) * parseFloat(array[i].cost.replace(/\./g, ''))
      }
      return sum.toString()
    },
    getTotalMargin: function () {
      var array = this.order.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += array[i].qty * array[i].margin
      }
      return sum.toString()
    },
    getGrossProfit: function () {
      var total = 0
      total = parseFloat(this.getTotal) - parseFloat(this.getTotalCost)
      return total
    },
    getGrossProfitPercentage: function () {
      var total = 0
      total = (this.getGrossProfit / parseFloat(this.getTotal)) * 100
      return Math.ceil(total)
    },
    getNetProfit: function () {
      var total = this.getGrossProfit - this.getTotalExpense
      return total
    },
    getNetProfitPercentage: function () {
      var total = 0
      total = (this.getNetProfit / parseFloat(this.getTotal)) * 100
      return Math.ceil(total)
    },
    getSubtotal: function () {
      var array = this.order.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (isNaN(array[i].total) === false) {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    getSubtotal2: function () {
      var array = this.order.details
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price.replace(/\./g, '')) * parseFloat(array[i].qty)
      }
      return sum.toString()
    },
    getTax: function () {
      var subtotal = this.getSubtotal
      var discount = parseFloat(this.order.discount.replace(/\./g, ''))
      var taxId = this.order.tax_id
      var taxAmount = 0
      var taxLis = this.taxList.find(d => d.id === taxId)
      if (taxLis) {
        if (taxLis.include === false) {
          taxAmount = (subtotal - discount) * (parseInt(taxLis.amount) / 100)
          return taxAmount.toString()
        } else {
          return '0'
        }
      } else {
        return '0'
      }
    },
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = []
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    getTotal () {
      var subtotal = this.getSubtotal2
      var discount = parseFloat(this.order.discount.replace(/\./g, ''))
      var subtotal2 = subtotal - discount
      var total = parseFloat(subtotal2) + parseFloat(this.order.tax)
      return total.toString()
    }
  },
  methods: {
    async getSpNo () {
      var data = {
        project_name: this.order.project_name
      }
      await axios.post(saleOrderUrl + '/get-sp-no', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          this.error.project_name = ''
        })
        .catch(error => {
          console.log(error.response)
          this.error.project_name = error.response.data.message
        })
    },
    async unlock () {
      var body = {
        id: this.order.id
      }
      await this.$swal.fire({
        title: 'Are you sure unlock this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#28A745',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Unlock it!'
      }).then((result) => {
        if (result.value) {
          axios.post(saleOrderUrl + '/unlock', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
              this.$swal('Success', response.data.message, 'success')
              this.backParent()
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async checkDate () {
      var date1 = new Date()
      date1.setHours(0, 0, 0, 0)
      var date2 = new Date(this.order.order_date)
      date2.setHours(0, 0, 0, 0)
      var remaining = date2.getTime() - date1.getTime()
      var diffInDay = (Math.round(remaining / (1000 * 3600 * 24)))
      console.log('Diff in a day ' + diffInDay)
      if (diffInDay > 0) {
        this.$swal('Error', 'Tanggal tidak boleh lebih dari hari ini (' + diffInDay + ' hari)', 'error')
        this.purchasing.purchasing_date = date1.toISOString()
      } else if (Math.abs(diffInDay) > 2) {
        this.$swal('Error', 'Tanggal tidak boleh kurang dari 2 hari', 'error')
        this.purchasing.purchasing_date = date1.toISOString()
      }
    },
    async validateDetailDuplicate () {
      this.alert = []
      var array = this.order.details
      var result = []
      var resultProductNo = []
      var resultProductUom = []
      array.reduce(function (res, value) {
        // Check product_no null & duplicate
        if (value.product_no !== null) {
          var price = value.price.replace(/\./g, '')
          var key = value.product_no + price
          console.log(key)
          if (!res[key]) {
            res[key] = {
              id: key,
              product_no: value.product_no,
              price: parseFloat(price).toLocaleString('id-ID')
            }
          } else {
            result.push({
              id: key,
              product_no: value.product_no,
              price: parseFloat(price).toLocaleString('id-ID')
            })
          }
          // check uom null
          if (value.uom_id === null) {
            resultProductUom.push({
              id: value.id + 'uom',
              product_no: value.product_no
            })
          }
        } else {
          resultProductNo.push({
            id: res
          })
        }
        return res
      }, {})
      if (result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          this.alert.push({
            message: 'Duplicate Product & Price (<b>' + result[i].product_no + ' | ' + result[i].price + '</b>)'
          })
        }
      }
      if (resultProductUom.length > 0) {
        for (let z = 0; z < resultProductUom.length; z++) {
          this.alert.push({
            message: 'Uom cannot be null ' + resultProductUom[z].product_no
          })
        }
      }
      if (this.order.project_name === null) {
        this.alert.push({
          message: '<b>SP No</b> harus diinput terlebih dahulu'
        })
      }
      if (this.order.salesman_id === null) {
        this.alert.push({
          message: '<b>Salesman</b> harus diinput terlebih dahulu'
        })
      }
      if (this.order.customer_no === null) {
        this.alert.push({
          message: '<b>Customer</b> harus diinput terlebih dahulu'
        })
      }
      var detailLength = this.order.details.length
      var detailNull = this.order.details.filter(d => d.product_no === null)
      if (parseFloat(detailNull.length) === parseFloat(detailLength)) {
        this.alert.push({
          message: '<b>Product</b> harus diinput terlebih dahulu'
        })
      }
    },
    async requestEdit (value) {
      var sales = this.order.sales.filter(d => d.id !== null)
      var note = ''
      if (sales.length > 0) {
        // this.$swal('Validation', '<b>Order</b> sudah diproses penjualan, cek <b>Penjualan</b> terlebih dahulu', 'error')
        // return false
        note = '[already sales]'
      }
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.order.order_no,
        lock_note: value + ' ' + note,
        type: 'sales-order'
      }
      console.log(obj)
      await axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Lock', 'Order has been requested (' + this.order.order_no + ')', 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async requestVoid (value) {
      var sales = this.order.sales.filter(d => d.id !== null)
      if (sales.length > 0) {
        this.$swal('Validation', '<b>Order</b> sudah diproses penjualan, cek <b>Penjualan</b> terlebih dahulu', 'error')
        return false
      }
      var obj = {
        request_by: this.authUser.username,
        lock_no: this.order.order_no,
        lock_note: value,
        type: 'sales-order-void'
      }
      console.log(obj)
      await axios.post(lockUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Lock', 'Order has been requested (' + this.order.order_no + ')', 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async removeOrder () {
      await this.$swal.fire({
        title: 'Are you sure Delete this?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {
          axios.delete(saleOrderUrl + '/' + this.order.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.message)
              this.$swal('Success', response.data.message, 'success')
              this.backParent()
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              this.$swal('Error', error.response.data.message, 'error')
              throw error
            })
        }
      })
    },
    async resetOrderDone () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        array[i].qty_done = 0
      }
      this.$Progress.finish()
      this.loader.isLoading = false
    },
    async syncOrderAll () {
      this.$Progress.start()
      this.loader.isLoading = true
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        await this.syncOrder(i, 'no reply')
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      await this.$swal('Success', 'Success sync order to sales', 'success')
    },
    async syncOrder (index, reply) {
      this.$Progress.start()
      this.loader.isLoading = true
      var detail = this.order.details[index]
      var obj = {
        product_no: detail.product_no,
        order_no: this.order.order_no,
        price: detail.price.replace(/\./g, ''),
        uom_id: detail.uom_id
      }
      console.log(obj)
      console.log(saleOrderUrl + '/sync-to-sales')
      await axios.post(saleOrderUrl + '/sync-to-sales', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.$Progress.finish()
          this.loader.isLoading = false
          if (reply === 'reply') {
            this.$swal('Success', response.data.message, 'success')
          }
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    getSaleNo (sale) {
      var obj = {
        sale_no: sale
      }
      this.$store.dispatch('getSaleByNo', obj)
    },
    selectProductToSaleList (product) {
      if (this.searchQueryOrder === null || this.searchQueryOrder === '') {
        this.searchQueryOrder = product
        this.card1 = 'col-md-8'
        this.card2 = 'col-md-4'
      } else if (this.searchQueryOrder === product) {
        if (this.searchQueryOrder !== product) {
          this.searchQueryOrder = ''
        } else {
          this.searchQueryOrder = ''
        }
        this.card1 = 'col-md-12'
        this.card2 = null
      }
    },
    async getCustomerOrder () {
      var obj = {
        customer_no: this.order.customer_no
      }
      await axios.post(customerUrl + '/order', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    async processSales (sales) {
      await axios.post(salesUrl, sales, { headers: getHeader() })
        .then(response => {
          this.$emit('backReload', this.order.id)
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
        })
        .catch(error => {
          console.log(error.response.data)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    setSalesInvoice () {
      var array = this.order.details
      var loopDetail = []
      var obj = {}
      var warehouse = this.warehouseList.find(d => d.company_no === this.authUser.company_no)
      for (let i = 0; i < array.length; i++) {
        var qty = parseInt(array[i].qty) - parseInt(array[i].qty_done)
        obj = {
          sale_date: null,
          branch_no: array[i].branch_no,
          product_no: array[i].product_no,
          product_sku: null,
          description: array[i].description,
          qty: qty,
          serial_number: array[i].serial_number,
          uom_id: array[i].uom_id,
          uomList: array[i].uomList,
          price: array[i].price,
          tax_id: array[i].tax_id,
          tax: array[i].tax,
          discount: array[i].discount,
          total: array[i].total,
          queue: null,
          warehouse_no: warehouse ? warehouse.warehouse_no : null,
          internal_code: null,
          cost: array[i].cost,
          cost_id: array[i].cost_id,
          sec_serial_number: null,
          company_no: this.authUser.company_no
        }
        console.log(obj)
        loopDetail.push(obj)
      }
      this.dataSales = {
        sale_date: new Date().toISOString(),
        sale_due_date: null,
        type_id: 1,
        customer_no: this.order.customer_no,
        customer: this.order.customer,
        branch_no: this.order.branch_no,
        warehouse_no: null,
        subtotal: this.order.subtotal,
        tax_id: this.order.tax_id,
        taxes: this.order.taxes,
        tax: this.order.tax,
        discount: this.order.discount,
        total: this.order.total,
        delivery_cost: this.order.delivery_cost,
        deliver_no: this.order.deliver_no,
        salesman_id: this.order.salesman_id,
        price_id: this.order.price_id,
        order_no: this.order.order_no,
        company_no: this.authUser.company_no,
        status: 'order',
        details: loopDetail
      }
    },
    getTermCondition: function () {
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      var obj = this.salesTermConditionList.find(d => d.term_no === this.order.term_no)
      var newDueDate = new Date(this.order.order_due_date)
      var month = monthNames[(newDueDate.getMonth() + 1)]
      var dueDate = newDueDate.getDate() + '/' + month + '/' + newDueDate.getFullYear()
      this.order.term_notes = obj.notes.replace('{date}', dueDate)
    },
    getProductList: function () {
      var date = new Date(this.order.order_date)
      var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
      var obj = {
        priceID: this.order.price_id,
        branch: this.order.branch_no,
        warehouse: null,
        date: newDate
      }
      console.log(obj)
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    selectTemplate: function (tmp) {
      console.log('select template')
      this.order.details = []
      var array = tmp.details
      var tax = this.taxList.find(d => d.id === this.order.tax_id)
      for (let i = 0; i < array.length; i++) {
        console.log(array[i].product_no)
        var value = this.productList.find(d => d.product_no === array[i].product_no)
        console.log(value)
        var dpp = value.price
        var totalTax = dpp * tax.amount / 100
        if (tax.include === false) {
          totalTax = dpp * tax.amount / 100
        } else {
          totalTax = 0
        }
        var obj = {
          order_no: null,
          branch_no: this.order.branch_no,
          product_no: value.product_no,
          description: value.product_name,
          qty: array[i].qty,
          serial_number: null,
          uom_id: value.uom_id,
          price: value.price,
          tax_id: null,
          tax: totalTax,
          discount: 0,
          total: value.price,
          state: 'create',
          uomList: value.uomList,
          cost: value.product_cost.toString(),
          cost_id: value.cost_id,
          margin: 0
        }
        this.order.details.push(obj)
      }
    },
    async createNewOrder () {
      await axios.post(saleOrderUrl + '/duplicate', this.order, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backReload', response.data.data.id)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async downloadAttachments (id, filename) {
      await axios({
        url: saleOrderUrl + '/attachment/' + id,
        method: 'GET',
        responseType: 'blob',
        headers: getHeader()
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]))
        var fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', filename)
        document.body.appendChild(fileLink)
        fileLink.click()
      })
    },
    removeAttachments (id) {
      var attch = this.order.attachments.find(d => d.id === id)
      var index = this.order.attachments.findIndex(d => d.id === id)
      console.log(attch.url)
      if (attch.order_no === null) {
        this.order.attachments.splice(index, 1)
      } else {
        this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(saleOrderUrl + '/attachment/' + attch.url, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                this.order.attachments.splice(index, 1)
              })
              .catch(error => {
                console.log(error.response)
              })
          }
        })
      }
    },
    handleFileUpload: function () {
      this.file = this.$refs.file.files[0]
    },
    async upload () {
      this.loading = true
      this.uploading = false
      const formData = new FormData()
      formData.append('file', this.file)
      if (this.order.order_no) {
        formData.append('order_no', this.order.order_no)
      }
      console.log(formData)
      const newHeader = {
        'Content-Type': 'multipart/form-data'
      }
      const newObj = Object.assign(getHeader(), newHeader)
      await axios.post(saleOrderUrl + '/attachment', formData, { headers: newObj })
        .then(response => {
          console.log(response.data.data)
          const data = response.data.data
          var newId = null
          if (data.id === null) {
            newId = Math.floor(Math.random() * (99999999 - 66666666) + 66666666)
          } else {
            newId = data.id
          }
          this.order.attachments.push({
            id: newId,
            order_no: data.order_no,
            filename: data.filename,
            url: data.url,
            extension: data.extension,
            real_path: data.real_path,
            size: data.size,
            mime_type: data.mime_type,
            upload_date: data.upload_date,
            queue: null
          })
        })
        .catch(error => {
          console.log(error)
          this.$swal(
            'Error',
            'Failed to upload',
            'error'
          )
        })
      this.loading = false
      this.uploading = true
    },
    printSO: function () {
      window.open(sale2Url + '/print/' + this.order.id + '/so', '_blank')
    },
    async approveSales () {
      var obj = {
        id: this.order.id
      }
      await axios.post(saleOrderUrl + '/approve/', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Success',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    async dealSales () {
      var obj = {
        id: this.order.id
      }
      await axios.post(saleOrderUrl + '/dealing', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal(
            'Deal',
            response.data.message,
            'success'
          )
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '<pre>' + error.response + '</pre>',
            'error'
          )
        })
    },
    setTax: function () {
      // var tax = this.taxList.find(d => d.id === this.order.tax_id)
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        this.calcRowPrice(i)
      }
    },
    setTaxTotal () {
      var sum = 0
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].tax) * parseFloat(array[i].qty)
      }
      return sum
    },
    calcRowPrice: function (index) {
      var qty = this.order.details[index].qty
      var amount = parseFloat(this.order.details[index].price.toString().replace(/\./g, ''))
      var discountPercentage = parseFloat(this.order.details[index].discount_percentage)
      var discount = amount * discountPercentage / 100
      console.log(discount)
      var tax = this.taxList.find(d => d.id === this.order.tax_id)
      var subtotal = amount - discount
      var dpp = 0
      var taxAmount = 0
      if (tax.include === false) {
        taxAmount = subtotal * tax.amount / 100
        dpp = subtotal
      } else {
        if (tax.amount === '0') {
          taxAmount = 0
          dpp = subtotal
        } else {
          if (tax.amount === '11') {
            dpp = subtotal / 1.11
            taxAmount = subtotal - dpp
          } else {
            dpp = subtotal / 1.1
            taxAmount = subtotal - dpp
          }
        }
      }
      this.order.details[index].discount = discount.toString()
      this.order.details[index].subtotal = Math.round(dpp)
      this.order.details[index].tax = Math.round(taxAmount)
      this.order.details[index].total = (Math.round(dpp) + Math.round(taxAmount)) * qty

      this.order.discount = this.totalDetailDiscount
      this.order.subtotal = this.totalDetailSubtotal
      this.order.tax = this.totalDetailTax
      this.order.total = this.totalDetail
    },
    calcRow (index) {
      var detail = this.order.details[index]
      var priceRatio = detail.uomList.find(i => i.id === detail.uom_id)
      var price = 0
      console.log(priceRatio)
      if (priceRatio.ratio === '0') {
        price = priceRatio.price
        detail.price = price.toString()
      } else {
        price = priceRatio.price * priceRatio.ratio
        detail.price = price.toString()
      }
      this.calcRowPrice(index)
      // detail.total = parseFloat(detail.qty) * parseFloat(detail.price)
    },
    setIdDetail: function (id) {
      this.idDetail = id
      this.$refs.refreshProduct.refresh()
      // var payload = {
      //   date: this.order.sale_date
      // }
      // this.$store.dispatch('getProductWithTotal', payload)
      // this.getType()
    },
    getType: function () {
      var date = new Date(this.order.order_date)
      var newDate = date.getFullYear() + '-' + (parseInt(date.getMonth()) + 1) + '-' + date.getDate()
      var obj = {
        priceID: this.order.price_id,
        branch: this.order.branch_no,
        warehouse: null,
        date: newDate
      }
      console.log(obj)
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    onBarcodeScanned (barcode) {
      var obj = {
        barcode: barcode
      }
      console.log(barcode)
      axios.post(productUrl + '/scan/barcode', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          const product = response.data.data
          var productDetail = this.order.details.find(d => d.product_no === product.product_no)
          if (productDetail) {
            productDetail.qty = parseInt(productDetail.qty) + 1
            productDetail.total = parseInt(productDetail.qty) * parseFloat(productDetail.price)
          } else {
            // const price = product.productGet.uomList.find(d => d.category_id === 3)
            var obj = {
              id: Math.floor(Math.random() * (99999999 - 66666666) + 66666666),
              product_no: product.product_no,
              product: product.productGet.product_name,
              description: product.productGet.product_description,
              qty: 1,
              uom_id: product.productGet.uom_id,
              price: product.price,
              discount: '0',
              total: product.price,
              state: null,
              uomList: product.productGet.uomList
            }
            this.order.details.push(obj)
          }
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    getCustomerList: function () {
      // this.$store.dispatch('getCustomerList')
    },
    createCustomer: function (customer) {
      console.log(customer)
      this.order.customer_no = customer.customer_no
      this.order.customer = customer
    },
    checkTax: function () {
      var cmp = this.companyList.find(d => d.company_no === this.order.company_no)
      this.order.tax_id = cmp.tax_id
      this.setTax()
    },
    detailClear: function () {
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        // array[i].edit = false
      }
    },
    backParent () {
      this.alert = []
      this.$emit('backClicked')
    },
    async updateSales () {
      await this.validateDetailDuplicate()
      if (this.alert.length > 0) {
        await window.scrollTo(0, 0)
        await this.$swal('Error', 'Data Order Belum valid, cek inputan terlebih dahulu', 'error')
        return false
      }
      this.$Progress.start()
      this.loader.isLoading = true
      var obj = {}
      var array = this.order.details
      var qtys = this.order.qtys
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_no !== null) {
          if (qtys.length > array.length) {
            console.log('update')
            for (let j = 0; j < qtys.length; j++) {
              if (array[i].product_no === qtys[j].product_no) {
                qtys[j].customer_no = this.order.customer_no
                qtys[j].product_no = array[i].product_no
                qtys[j].ref_no = this.order.order_no
                qtys[j].qty = array[i].qty
                qtys[j].uom_id = array[i].uom_id
                qtys[j].qty_date = this.order.order_date
                qtys[j].type = 'in'
                qtys[j].status = 'updated'
                qtys[j].company_no = this.order.company_no
              }
            }
          } else {
            console.log('create')
            obj = {
              customer_no: this.order.customer_no,
              product_no: array[i].product_no,
              ref_no: this.order.order_no,
              qty: array[i].qty,
              uom_id: array[i].uom_id,
              qty_date: this.order.order_date,
              type: 'in',
              status: 'created',
              company_no: this.order.company_no
            }
            this.order.qtys.push(obj)
          }
        }
      }
      this.order.status = 'approved'
      this.order.lock = true
      await axios.put(saleOrderUrl + '/' + this.order.id, this.order, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async validateCustomer () {
      let check = false
      if (this.order.customer.rating_id === 'vip') {
      } else {
        if (this.isEnablePlafondDueDate) {
          let ots = 0
          if (this.customerOutstandingDueTotal === null) {
            ots = '0'
          } else if (typeof this.customerOutstandingDueTotal === 'string') {
            ots = parseFloat(this.customerOutstandingDueTotal).toLocaleString('id-ID')
          } else {
            ots = parseFloat(this.customerOutstandingDueTotal).toLocaleString('id-ID')
          }
          const settingPlafond = this.settingList.find(d => d.name === 'customer_sales_plafond_due_date_enable' && d.company_no === this.order.company_no)
          const maxAge = settingPlafond ? settingPlafond.value : 0
          if (parseFloat(this.customerOutstandingDueTotal) > 0) {
            await this.$swal('Error', 'Penjualan tidak dapat diproses<br> masih ada piutang > ' + maxAge + ' <strong>' + ots + '</strong>', 'error')
            check = true
          }
        }
        if (this.isEnablePlafond) {
          if (this.customerPlafondAmount !== 0) {
            if (parseFloat(this.customerOutstandingTotal) >= parseFloat(this.customerPlafondAmount)) {
              let plafondAmount = 0
              let outstanding = 0
              // plafon
              if (this.customerPlafondAmount === null) {
                plafondAmount = '0'
              } else if (typeof this.customerPlafondAmount === 'string') {
                plafondAmount = parseFloat(this.customerPlafondAmount).toLocaleString('id-ID')
              } else {
                plafondAmount = parseFloat(this.customerPlafondAmount).toLocaleString('id-ID')
              }
              // outstanding
              if (this.customerOutstandingTotal === null) {
                outstanding = '0'
              } else if (typeof this.customerOutstandingTotal === 'string') {
                outstanding = parseFloat(this.customerOutstandingTotal).toLocaleString('id-ID')
              } else {
                outstanding = parseFloat(this.customerOutstandingTotal).toLocaleString('id-ID')
              }
              await this.$swal('Error', 'Penjualan tidak dapat diproses<br>Plafond piutang (' + plafondAmount + ') tidak mencukupi. Piutang: <strong>' + outstanding + '</strong>', 'error')
              check = true
            }
          }
        }
        if (this.order.customer.rating_id === 'evaluate' && parseFloat(this.customerOutstandingTotalSalePaid) === 0 && parseFloat(this.customerOutstandingTotalSales > 1)) {
          await this.$swal('Error', 'Penjualan tidak dapat diproses, customer masih dalam evaluasi dan ada piutang', 'error')
          check = true
        }
        // restrict by rating
        if (this.order.customer.rating_id === 'middle-high' || this.order.customer.rating_id === 'bad' || this.order.customer.rating_id === 'black-list') {
          check = true
          await this.$swal('Error', 'Customer Rating (' + this.order.customer.rating + ') not valid.', 'error')
        }
      }
      this.validateCustomerStatus = check
    },
    async createSales () {
      await this.validateCustomer()
      if (this.validateCustomerStatus) {
        return false
      }
      await this.validateDetailDuplicate()
      if (this.alert.length > 0) {
        await window.scrollTo(0, 0)
        await this.$swal('Error', 'Data Order Belum valid, cek inputan terlebih dahulu', 'error')
        return false
      }
      this.$Progress.start()
      this.loader.isLoading = true
      this.order.status = 'approved'
      this.order.lock = true
      var obj = {}
      var array = this.order.details
      for (let i = 0; i < array.length; i++) {
        if (array[i].product_no !== null) {
          obj = {
            customer_no: this.order.customer_no,
            product_no: array[i].product_no,
            ref_no: this.order.order_no,
            qty: array[i].qty,
            uom_id: array[i].uom_id,
            qty_date: this.order.order_date,
            type: 'in',
            status: 'created',
            company_no: this.order.company_no
          }
          this.order.qtys.push(obj)
        }
      }
      await axios.post(saleOrderUrl, this.order, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$swal('Success', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    validateDetail () {
      var array = this.order.details.filter(d => d.product_no !== null)
      var productNO = []
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].qty) <= 0) {
          productNO.push({
            product_no: array[i].product_no
          })
        }
        if (array[i].uom_id === null || array[i].uom_id === '') {
          productNO.push({
            product_no: array[i].product_no
          })
        }
      }
      return productNO
    },
    addNewLine: function () {
      // this.$store.dispatch('getProductList')
      // var newID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
      this.order.details.push({
        order_no: null,
        order_date: null,
        branch_no: null,
        branch: null,
        product_no: null,
        product: null,
        description: null,
        qty: 1,
        qty_done: '0',
        serial_number: null,
        uom_id: null,
        uomList: [{
          id: null,
          name: null,
          category_id: null,
          type_id: null,
          ratio: '0',
          active: false,
          cost: '0',
          price: '0'
        }],
        price: '0',
        discount: 0,
        discount_percentage: '0',
        margin: 0,
        margin_percentage: 0,
        tax_id: null,
        tax: '0',
        subtotal: '0',
        total: '0',
        queue: null,
        state: null,
        cost: '0',
        cost_id: null
      })
      this.state = 'create'
      // sales type
      // var styp = this.salesTypeList.find(d => d.id === this.sales.type_id)
      // var obj = {
      //   salesType: styp.name
      // }
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    editDetail: function (id) {
      // var p = this.sales.details.find(d => d.id === id)
      this.idDetail = id
      // sales type
      // var styp = this.salesTypeList.find(d => d.id === this.sales.type_id)
      // var obj = {
      //   salesType: styp.name
      // }
      // this.$store.dispatch('getProductByPriceList', obj)
    },
    async removeDetail (index) {
      var detail = this.order.details[index]
      console.log(detail)
      if (typeof detail.id === 'undefined') {
        this.order.details.splice(index, 1)
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(saleOrderUrl + '/detail/' + detail.id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
              .then(response => {
                console.log(response.data.message)
                this.order.details.splice(index, 1)
              })
              .catch(error => {
                console.log(error)
                console.log(error.response)
                this.$swal('Error', error.response.data.message, 'error')
                throw error
              })
          }
        })
      }
    },
    async selectProduct (value) {
      console.log('start select product')
      this.$Progress.start()
      this.loader.isLoading = true
      var arr = this.order.details.filter(d => d.product_no !== null)
      var dtl = arr.find(d => d.product_no === value.product_no)
      console.log(dtl)
      // if (dtl) {
      //   this.$swal('Error', 'Product already pick', 'error')
      //   this.$Progress.finish()
      //   this.loader.isLoading = false
      //   return false
      // }
      var data = {
        product_no: value.product_no,
        date: this.order.order_date
      }
      await axios.post(productUrl + '/latest-price', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          var product = response.data.data
          var detail = this.order.details[this.idDetail]
          var tax = this.taxList.find(d => d.id === this.order.tax_id)
          console.log(tax)
          var amount = parseFloat(product.price)
          var subtotal = amount
          var dpp = 0
          var taxAmount
          if (tax.include === false) {
            taxAmount = subtotal * tax.amount / 100
            dpp = subtotal
          } else {
            if (tax.amount === '0') {
              taxAmount = 0
              dpp = subtotal
            } else {
              taxAmount = subtotal * (tax.amount / 100)
              dpp = subtotal - taxAmount
            }
          }
          detail.order_no = this.order.order_no
          detail.branch_no = this.order.branch_no
          detail.product_no = product.product_no
          detail.description = product.product_name
          detail.qty = 1
          detail.serial_number = null
          detail.uom_id = product.uom_id
          detail.price = product.price.toString()
          detail.tax_id = tax.id
          detail.tax = taxAmount
          detail.discount = 0
          detail.subtotal = dpp
          detail.total = product.price
          detail.state = 'create'
          detail.uomList = product.uomList
          detail.cost = 0
          detail.cost_id = null
          detail.margin = 0
          detail.margin_percentage = 0
          this.setTax()
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
      var body = {
        product_no: value.product_no
      }
      await axios.post(productUrl + '/uom/list', body, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          var dt = this.order.details[this.idDetail]
          console.log(response.data.message)
          dt.uomList = response.data.data
          dt.uom_id = value.uom_id
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async selectCustomerList (customer) {
      this.order.customer_no = customer.customer_no
      this.order.customer = customer
      const data = {
        company_no: this.order.company_no,
        customer_no: customer.customer_no
      }
      // await this.$store.dispatch('getCustomerOutstadingTotal', data)
      await axios.post(customerUrl + '/sales-outstanding-expire', data, { headers: getHeader() })
        .then(response => {
          console.log(response.data)
          this.$store.commit('SET_CUSTOMER_OUTSTANDING_TOTAL', response.data.total_outstanding)
          this.$store.commit('SET_CUSTOMER_OUTSTANDING_TOTAL_SALES', response.data.total_sales)
          this.$store.commit('SET_CUSTOMER_OUTSTANDING_TOTAL_SALES_PAID', response.data.total_sales_paid)
          this.$store.commit('SET_CUSTOMER_OUTSTANDING_DUE_TOTAL', response.data.total_outstanding_due)
          this.$store.commit('SET_CUSTOMER_PLAFOND_AMOUNT', response.data.plafond_amount)
          this.$store.commit('SET_CUSTOMER_OUTSTANDING_SALES_LIST', response.data.data)
          this.order.customer.rating_id = response.data.rating_id
          this.order.customer.rating = response.data.rating
        })
        .catch(error => {
          console.log(error)
        })
      await axios.post(saleOrderUrl + '/get-latest-order', data, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          var sales = response.data.data
          this.order.salesman_id = sales.salesman_id
          this.order.term_due_id = sales.term_due_id
        })
        .catch(error => {
          console.log(error.response)
          // this.$swal('Error', error.response.data.message, 'error')
        })
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
</style>
